import React from 'react';
import Icon from '../../../components/AppIcon';

const LiveStatusBanner = ({ status }) => {
  const getLevelConfig = (level) => {
    const configs = {
      'critical': {
        bg: 'bg-error',
        icon: 'AlertTriangle',
        pulse: true
      },
      'warning': {
        bg: 'bg-warning',
        icon: 'AlertCircle',
        pulse: true
      },
      'normal': {
        bg: 'bg-success',
        icon: 'CheckCircle',
        pulse: false
      }
    };
    return configs?.[level] || configs?.normal;
  };

  const config = getLevelConfig(status?.level);

  return (
    <div className={`${config?.bg} text-white py-4 px-6 shadow-lg`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className={config?.pulse ? 'animate-pulse' : ''}>
            <Icon name={config?.icon} size={24} />
          </div>
          <div>
            <p className="font-semibold text-lg">{status?.details}</p>
            <p className="text-sm text-white/80">Last updated: {status?.lastUpdated}</p>
          </div>
        </div>
        <button className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg animation-organic">
          <Icon name="RefreshCw" size={16} />
          <span className="text-sm font-medium">Refresh</span>
        </button>
      </div>
    </div>
  );
};

export default LiveStatusBanner;